import { gridReportsApiSlice } from 'core/services/GridReportsApiSlice';
import type { AppDispatch } from 'core/store';
import { buildQueryParams } from './buildQueryParams';
import { sortFilterOptions } from './sortFilterOptions';
import { FetchParams } from '../models';

export interface GridFilterOptions {
  defaultBuCode: string;
  countries: string[];
}

const filterOptionsParams: FetchParams = {
  offset: 0,
  limit: 0,
  sortModel: [],
  filters: [],
};

const toStringList = (value: unknown): string[] =>
  Array.isArray(value) ? value.map(item => String(item)) : [];

export const fetchFilterOptions = async (
  dispatch: AppDispatch,
  selectedReport: string,
  activeProjectKey: string
): Promise<GridFilterOptions> => {
  const response = await dispatch(
    gridReportsApiSlice.endpoints.getGridReport.initiate({
      projectKey: activeProjectKey,
      reportId: selectedReport,
      query: buildQueryParams(filterOptionsParams).toString(),
    })
  ).unwrap();

  const buCodes = sortFilterOptions(toStringList(response.filter_values?.bu_code));
  if (buCodes.length === 0) {
    throw new Error('No BU_CODE values are available for this report');
  }

  return {
    defaultBuCode: buCodes[0],
    countries: toStringList(response.filter_values?.country_code),
  };
};
